import { createIcon } from '@chakra-ui/icon'

export const DeviceGroupIcon = createIcon({
  displayName: 'GoogleHomeDevicesSharp',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="currentColor"
      d="M8 21v-2H2V3h20v4h-2V5H4v12h7v4zm7.15-4.5q0-.975.688-1.662t1.662-.688t1.663.688t.687 1.662t-.687 1.663t-1.663.687t-1.662-.687t-.688-1.663M22 8v13h-9V8zm-4.5 1q-.65 0-1.075.425T16 10.5t.425 1.075T17.5 12t1.075-.425T19 10.5t-.425-1.075T17.5 9m0 11q1.475 0 2.488-1.012T21 16.5t-1.012-2.488T17.5 13t-2.488 1.013T14 16.5t1.013 2.488T17.5 20"
    />
  ),
})
